import { Component, inject } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogClose,
} from '@angular/material/dialog';
import { isValid, parseISO, startOfToday } from 'date-fns';
import {
  CASE_TYPE,
  ClaimControls,
  ClaimFileControls,
} from '../edit-case-dialog.service';
import { PayeePopupComponent } from '../../../shared/payee-popup/payee-popup.component';
import { PayeeFormFieldComponent } from '../../../shared/payee-form-fields/payee-form-field/payee-form-field.component';
import { PayeeIconComponent } from '../../../shared/payee-icon/payee-icon.component';
import { PayeeDatepickerComponent } from '../../../shared/payee-form-fields/payee-datepicker/payee-datepicker.component';
import { PayeeInputDirective } from '../../../shared/payee-input/payee-input.directive';
import { PayeeButtonComponent } from '../../../shared/payee-buttons/payee-button/payee-button.component';

export type DialogData = {
  claimForm: FormGroup<ClaimControls>;
  fileForm: FormGroup<ClaimFileControls>;
};

@Component({
  selector: 'app-add-claim-evidence-dialog',
  templateUrl: './add-claim-evidence-dialog.component.html',
  styleUrls: ['./add-claim-evidence-dialog.component.scss'],
  imports: [
    PayeePopupComponent,
    FormsModule,
    ReactiveFormsModule,
    PayeeFormFieldComponent,
    PayeeIconComponent,
    PayeeDatepickerComponent,
    PayeeInputDirective,
    PayeeButtonComponent,
    MatDialogClose,
  ],
})
export class AddClaimEvidenceDialogComponent {
  dialogRef =
    inject<MatDialogRef<AddClaimEvidenceDialogComponent>>(MatDialogRef);
  data = inject<DialogData>(MAT_DIALOG_DATA);

  get max() {
    const claim = this.data.claimForm.value;
    const dueDate =
      claim.due_date_at instanceof Date
        ? claim.due_date_at
        : parseISO(claim.due_date_at!);
    return isValid(dueDate) ? dueDate : startOfToday();
  }
  readonly CASE_TYPE = CASE_TYPE;

  get caseTypeControl() {
    return this.data.fileForm.controls.case_type;
  }
}
